/** Spaces shown per page on the "My Listings" page. */
export const MY_LISTINGS_PAGE_SIZE = 10;
